import { Routes } from '@angular/router';

import moduleRoutes from './modules/routes';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./core/views/default/default.component'),
    children: [...moduleRoutes],
  },
  {
    path: 'page-not-found',
    loadComponent: () => import('./core/views/not-found/not-found.component'),
  },
  { path: '**', redirectTo: 'page-not-found' },
];
